export default "__VITE_ASSET__BuG2U$ZV__"